import React from "react";
import { useSelector } from "react-redux";
import Modal from "../Common/Modal";
import useClickExternalLink from "../../hooks/useClickExternalLink";
import i18n from "../../i18n/config";
import { RootState } from "../../types/redux";

interface DisclosureDoc {
  title: string;
  url: string;
}

interface DisclosureModalProps {
  docs: DisclosureDoc[];
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

const DisclosureModal = ({
  showModal,
  setShowModal,
  docs,
}: DisclosureModalProps) => {
  const openExternalLinksModal = useClickExternalLink();
  const { open } = useSelector(
    (state: RootState) => state.global.externalLinksModal
  );

  const documents = docs.map((doc) => (
    <tr key={doc.url}>
      <td>
        <span
          className="text-underline"
          dangerouslySetInnerHTML={{ __html: doc.title }}
        ></span>
      </td>
      <td>
        <a
          href={doc.url}
          target="_blank"
          rel="noreferrer noopener"
          className="btn btn-secondary small"
          onClick={(e) => openExternalLinksModal(e, doc.url)}
          title={i18n.t("COMMON.EXTERNAL_LINK_TITLE")}
        >
          <span className="sr-only">{doc.title}</span>{/*}
          */}View
        </a>
      </td>
    </tr>
  ));

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      title="Disclosures"
      className={`disclosure-modal ${open ? "hide" : ""} v2 v3`}
      content={
        <table className="navigatorTable">
          <tbody>{documents}</tbody>
        </table>
      }
    />
  );
};

export default DisclosureModal;